// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"fb1416d4","218":"d6a3eecc","488":"daacfcfc","586":"8503b78b","593":"7bb1f3a6","662":"6dd043b9","892":"5cde83ed","906":"ade12ef6","912":"afc3df82","970":"8ad76f3e","979":"34d50380","992":"e4947369"}[chunkId] + ".chunk.js";
};